/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";

import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";

import {
  container
} from "../common";

const ruppeeSymbol = `${WealthyEnv.BROKING_CDN_URL}/ruppee-symbol.png`;
const goldenRuppeeIcon = `url(${WealthyEnv.BROKING_CDN_URL}/golden-ruppee-icon.png)`;

const PriceTable = () => {
  return (
    <>
      <PriceTableWrapper>
        <BrokerageSection>
          <BrokerageCardsWrapper>
            <CardItem>
              <PriceSection>
                <Price>0 <StarSymbol>*</StarSymbol></Price>
              </PriceSection>
              <Title>Account Maintenance Charges</Title>
            </CardItem>
            <CardItem>
              <PriceSection>
                <Price>0</Price>
              </PriceSection>
              <Title>Account Opening Charges</Title>
            </CardItem>
            <CardItem>
              <PriceSection>
                <Price className="price order-price">15 <DoubleStarSymbol>**</DoubleStarSymbol></Price>
              </PriceSection>
              <Title>Equity Brokerage</Title>
            </CardItem>
          </BrokerageCardsWrapper>
        </BrokerageSection>
      </PriceTableWrapper>
    </>
  );
};

const PriceTableWrapper = styled.section`
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -170px;
    right: 0;
    height: 270px;
    width: 150px;
    background-image: ${goldenRuppeeIcon};
    background-size: cover;
    background-repeat: no-repeat;
  }

  @media (max-width: 576px) {
    &::after {
      width: 75px;
      height: 80px;
      background-size: contain;
      bottom: -30px;
    }
  }
`;

const BrokerageSection = styled(container)`
  margin: 10rem auto;
  position: relative;
  max-width: 1000px;

  @media (max-width: 576px) {
    margin: 3.3rem auto;
    padding-bottom: 3.2rem;
  }
`;

const BrokerageCardsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const CardItem = styled.div`
  padding: 3.8rem 6.6rem;
  background: #FFF;
  text-align: center;
  width: 33.3%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  &:nth-child(3n+2) {
    border-right: 1px solid #DDD;
    border-left: 1px solid #DDD;
  }

  &:nth-child(n+4):nth-child(-n+6) {
    padding-top: 7.6rem;
    padding-bottom: 0;
  }

  @media (max-width: 768px) {
    width: 100%;

    &:nth-child(5) {
      border: none;
    }

    &:nth-child(2), &:nth-child(5) {
      border: none;
    }

    &:nth-child(4), &:nth-child(6) {
      border: none;
    }

    &:nth-child(n+3):nth-child(-n+4) {
      padding-top: 3.6rem;
      padding-bottom: 3.6rem;
    }

    &:nth-child(n+5):nth-child(-n+6) {
      padding: 0;
    }
  }

  @media (max-width: 576px) {
    padding: 3.3rem 1.9rem 2rem;

    &:nth-child(n+5):nth-child(-n+6) {
      padding-top: 3.6rem;
      padding-bottom: 2rem;
    }
  }
`;

const PriceSection = styled.div`
  text-align: center;
`;

const Price = styled.p`
  font-size: 10rem;
  color: ${colors.primary};
  position: relative;
  line-height: 0.5;
  width: fit-content;
  margin: 0 auto;

  &.just-text{
      &::before {
      content: unset;
    }
  }

  &.price::after {
    content: "";
    position: absolute;
    bottom: 0;
    right: -40px;
    font-size: 1.6rem;
    color: ${colors.textGray};
  }

  &.lot-price::after {
    content: "/ lot";
  }

  &.order-price::after {
    content: "/ order";
    right: -60px;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -10px;
    height: 30px;
    width: 14px;
    scale: 0.6;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    background-image: url(${ruppeeSymbol});
  }

  @media (max-width: 768px) {
    font-size: 7.8rem;
  }

  @media (max-width: 576px) {
    font-size: 2.4rem;

    &::before {
      height: 15px;
      width: 7px;
      top: -5px;
      left: -10px;
    }

    &.price::after {
      font-size: 1rem;
      right: -20px;
    }

    &.order-price::after {
      right: -30px;
    }
  }
`;

const StarSymbol = styled.span`
  color: ${colors.black};
  position: absolute;
  top: -20px;
  right: -20px;
  scale: 0.4;
`;

const DoubleStarSymbol = styled.span`
  color: ${colors.black};
  position: absolute;
  top: -20px;
  right: -50px;
  scale: 0.3;
`;

const Title = styled.h2`
  font-size: 2rem;
  padding-top: 3rem;

  @media (max-width: 576px) {
    font-size: 1.2rem;
    padding-top: 1.2rem;
  }
`;

export default PriceTable;
